<kui-content-header [custom]="true" [sub]="true" class="datetime-bar no-border-top-nested">
    <div class="flex-stretch d-flex justify-content-center align-items-center">
        <kui-daterange-new
            [dateFormat]="'yyyy-MM-DD'"
            timeStrategy="day-extents"
            [disabled]="disabled()"
            [timePeriod]="chosenTimePeriod()"
            [timePeriods]="timePeriods"
            [customDatePicker]="true"
            [startDate]="startDate()"
            [endDate]="endDate()"
            [min]="minDate()"
            [max]="maxDate()"
            [noDatePlaceholder]="currentString()"
            [displayTimePeriodText]="displayTimePeriodText()"
            (onChangeTimePeriod)="handleChange($event)"
        >
        </kui-daterange-new>
    </div>

    @if (headerActions() && !disabled()) {
        <div class="d-flex justify-content-end pr-1">
            @for (action of headerActions().actions; track action.id) {
                <kui-icon kui-action class="pr-2" [class.active]="action.active" [name]="action.icon" [title]="action.name" (click)="action.click()"> </kui-icon>
            }
        </div>
    }
</kui-content-header>
